// Password policy shown and enforced in the UI. The backend enforces the same
// minimum independently (MIN_PASSWORD_LENGTH in backend/routes/auth.js) — this
// copy exists only so the forms can validate and label before submitting.
// Keep the two in sync.
//
// Applies to setting a password (register, create user, change, reset). Logging
// in is unaffected, so accounts created under the previous 6-character minimum
// continue to work until their owner changes their password.
export const MIN_PASSWORD_LENGTH = 8;

export const PASSWORD_HINT = `Password must be at least ${MIN_PASSWORD_LENGTH} characters long`;

// Message for a field labelled "new password" (change/reset flows)
export const NEW_PASSWORD_HINT = `New password must be at least ${MIN_PASSWORD_LENGTH} characters`;
